import { ZIndex } from "../../../common/UI/ZIndex.js";
import styled from "styled-components";
const RowDividerActionsHandle = styled.div`
  width: 100%;
  position: absolute;
  left: 0;
  bottom: -10px;
  transition: opacity 20ms ease-in;
  height: 10px;
  z-index: ${ZIndex.level700};

  ::after,
  ::before {
    background-color: ${({ theme }) => theme.column.header.dragHandle.idle};
    content: '';
    position: absolute;
    transition: opacity 60ms ease-in;
    opacity: 0;
    z-index: 1;
  }

  ::after {
    width: 100%;
    top: 0;
    height: 2px;
  }

  ::before {
    width: 100vw;
    pointer-events: none;
    top: 0;
    height: 2px;
    left: 0;
    position: absolute;
    opacity: 0;
    transition: opacity 60ms ease-in;
  }

  :hover {
    ::after {
      opacity: 1;
      top: 0;
      background-color: ${({ theme }) => theme.column.header.dragHandle.dragging};
    }

    ::before {
      opacity: 1;
      height: 2px;
      width: 100vw;
      background-color: ${({ theme }) => theme.column.header.dragHandle.dragging} !important;
      top: 0;
      left: 0;
      position: absolute;
    }
  }
`;
const StyledInsertRowButtonWrapper = styled.div`
  position: absolute;
  left: 100%;
  top: -10px;
  background: transparent;
  transition: opacity 150ms ease-in;
  z-index: ${ZIndex.level900};
  padding: 0 8px;
  display: none; /* Hide by default */

  ${RowDividerActionsHandle}:hover & {
    display: block; /* Show only on hover */
    pointer-events: auto;
  }
`;
const StyledInsertRowButton = styled.div`
  background-color: ${({ theme }) => theme.buttons.pill.backgroundColor};
  border: ${({ theme }) => `1px solid ${theme.buttons.pill.dropdown.borderColor}`};
  color: ${({ theme }) => theme.buttons.pill.color};
  border-radius: 3px;
  min-width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer !important;
  transition: opacity 150ms ease-in;
  padding: 0 8px;
  font-size: 12px;
  white-space: nowrap;
  box-shadow: 0px 1.05px 1.58px 0px #1b1b1e0a;
  box-shadow: 0px 2.63px 4.02px 0px #1b1b1e0e;
  pointer-events: auto !important;
  position: relative;
  z-index: ${ZIndex.level1000};

  svg {
    margin-right: 4px;
  }
`;
export {
  RowDividerActionsHandle,
  StyledInsertRowButton,
  StyledInsertRowButtonWrapper
};
